import Immutable from "seamless-immutable";
import { USER_TYPES } from "./actions";
import { createReducer } from "../../libs/saga-utils";

const DEFAULT_STATE = {
  isLoggingIn: false,
  isGettingData: false,
  loginError: null,
  dataError: null,

  user: null,
  tempUser: {}
};

const ACTIONS = {
  [USER_TYPES.LOGIN_SUCCESS]: loginSuccess,
  [USER_TYPES.LOGOUT_SUCCESS]: logoutSuccess,
  [USER_TYPES.LOGIN_FAILURE]: loginFailure,
  [USER_TYPES.LOGIN_2FA_REQUIRED]: login2FaRequired,
  [USER_TYPES.LOGIN_REQUEST]: loginRequest,
  [USER_TYPES.GET_DATA_FAILURE]: getDataFailure,
  [USER_TYPES.GET_DATA_SUCCESS]: getDataSuccess,
  [USER_TYPES.LOAD_LOCALSTORAGE_SUCCESS]: loginSuccess,
  [USER_TYPES.GET_DATA_REQUEST]: getDataRequest
};

function loginSuccess(state, { payload }) {
  const { user } = payload;
  return state.merge({
    isLoggingIn: false,
    tempUser: user,
    error: null
  });
}

function loginFailure(state, { payload }) {
  return state.merge({
    isLoggingIn: false,
    loginError: payload.response.data.message
  });
}

function login2FaRequired(state, { payload }) {
  return state.merge({
    isLoggingIn: false,
    error: null
  });
}

function logoutSuccess(state, { payload }) {
  window.location.href = "/login";
}

function loginRequest(state, { username }) {
  return state.merge({
    isLoggingIn: true,
    error: null,
    tempUser: { username }
  });
}

function getDataSuccess(state, { payload }) {
  const { user } = payload;
  user.token = state.tempUser.token;

  return state.merge({
    user,
    error: null,
    isGettingData: false
  });
}

function getDataFailure(state, { payload }) {
  const { error } = payload;
  return state.merge({ dataError: error, isGettingData: false });
}

function getDataRequest(state, { payload }) {
  return state.merge({ isGettingData: true });
}

const userReducer = createReducer(Immutable(DEFAULT_STATE), ACTIONS);

export default userReducer;
